/*
 * Units in an experiment design are short lower-case tokens, the same rule as
 * keys (routes/experiments.py _unit -> _token): "°C" is refused there with a
 * 400 the designer could only show after the whole design was sent. The
 * designer turns what people type into the token it will save, and shows it,
 * before anything is sent.
 */
const TOKEN = /^[a-z][a-z0-9_]{0,39}$/;

// Spelled-out forms of the symbols people actually type.
const KNOWN = {
  '°c': 'c', '℃': 'c', 'deg c': 'c', 'degc': 'c',
  '°f': 'f', '℉': 'f',
  '%': 'pct', '% rh': 'pct_rh', '%rh': 'pct_rh',
  'µm': 'um', 'μm': 'um', 'µl': 'ul', 'μl': 'ul', 'µg': 'ug', 'μg': 'ug',
};

/* The token a typed unit is saved as, or null when nothing usable is left. */
export function unitToken(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return '';
  const lower = text.toLowerCase().replace(/\s+/g, ' ');
  if (KNOWN[lower]) return KNOWN[lower];
  let token = lower
    .replace(/[µμ]/g, 'u')
    .replace(/°/g, '')
    .replace(/%/g, 'pct')
    .replace(/\//g, '_per_')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_');
  if (!token) return null;
  if (!/^[a-z]/.test(token)) token = `u_${token}`;
  token = token.slice(0, 40).replace(/_+$/, '');
  return TOKEN.test(token) ? token : null;
}

/* {token, changed, invalid} for showing a warning beside the field. */
export function unitCheck(raw) {
  const token = unitToken(raw);
  const typed = String(raw ?? '').trim();
  return { token, changed: token !== null && token !== typed, invalid: token === null };
}
